import { styled, Chip } from '@mui/material';
import { FC, useState } from 'react';
import Spacing from 'components/Spacing';
import Button from 'components/Button';
import Selector from './Selector';
import AddIcon from '@mui/icons-material/Add';
import { CategoryOptions, TagData } from './types';

const ChipsContainer = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '5px',
  minHeight: '37px',
  border: '1px solid rgba(0, 0, 0, 0.25)',
  borderRadius: '2px',
  padding: '5px 10px',
  maxWidth: '300px',
  width: '100%',
});

type CustomTagSectionProps = {
  onChange: (data: Array<TagData>) => void;
  onCategorySelect: (category: string) => void;
  categoryOptions: CategoryOptions;
  tags: Array<TagData>;
  selectedCategory?: string;
  tagOptions?: Array<string>;
  disabled?: boolean;
};

const CustomTagSection: FC<CustomTagSectionProps> = ({
  onChange,
  onCategorySelect,
  selectedCategory,
  tags,
  categoryOptions,
  tagOptions,
  disabled,
}) => {
  const [showSelector, setShowSelector] = useState(false);

  const handleDeleteCustomTag = (tag: TagData) => {
    onChange(
      tags.filter((t) => t.category !== tag.category || t.tag !== tag.tag),
    );
  };

  const hasCustomTags = !!tags.length && tags.length > 0;

  return (
    <Spacing size="md" direction="column" alignItems="stretch">
      {(hasCustomTags || !showSelector) && (
        <Spacing size="sm" direction="row" alignItems="center">
          {hasCustomTags && (
            <ChipsContainer>
              {tags.map((customTag) => {
                const selectedCategoryOption = categoryOptions.find(
                  (option) => option.value === customTag.category,
                );
                return (
                  <Chip
                    size="small"
                    key={`${customTag.category}-${customTag.tag}`}
                    label={`(${selectedCategoryOption?.label}: ${customTag.tag})`}
                    onDelete={
                      disabled
                        ? undefined
                        : () => handleDeleteCustomTag(customTag)
                    }
                  />
                );
              })}
            </ChipsContainer>
          )}
          {!showSelector && !disabled && (
            <Button
              onClick={() => setShowSelector(!showSelector)}
              variant="outlined"
              size="extra-small"
              startIcon={<AddIcon />}
            >
              Add
            </Button>
          )}
        </Spacing>
      )}
      {showSelector && (
        <Spacing size="sm" direction="row" alignItems="center">
          <Selector
            tagsHiddenFromOptions={tags}
            onCategorySelect={onCategorySelect}
            onTagSelect={(customTag) => {
              onChange([...(tags || []), customTag]);
              setShowSelector(false);
            }}
            selectedCategory={selectedCategory}
            categoryOptions={categoryOptions}
            tagOptions={tagOptions}
          />
          <Button
            onClick={() => setShowSelector(!showSelector)}
            variant="outlined"
            color="error"
          >
            Cancel
          </Button>
        </Spacing>
      )}
    </Spacing>
  );
};

export default CustomTagSection;
